export function leadershipMobileInfo() {
    const $body = $("body");
    const $leadershipItem = $(".leadership-item");
    $leadershipItem.each(function () {
        if ($(this).find(".leadership-item-info").length) {
            $(this).find(".leadership-item-info").append("<button class='mobile-close'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"25\" viewBox=\"0 0 24 25\" fill=\"none\">\n" +
                "          <path d=\"M9.75 10.25L14.25 14.75M14.25 10.25L9.75 14.75M21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5Z\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                "        </svg></button>");
        }
    });
    $leadershipItem.on("click", function () {
        if ($body.hasClass("touch")) {
            $(this).addClass("show");
        }
    });
    $body.on("click", ".mobile-close", function () {
        $(this).parents(".leadership-item").removeClass("show");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/leadershipMobileInfo.js